export default __webpack_public_path__ + "static/media/bg.06fe1d2c.jpg";